import {GET_NFT, GET_NFT_SUCCESS, NFT_API_ERROR} from "./actionTypes"

const initialState ={
    loading: false,
    nftData: [],
    errorMsg: "",
}


const nftReducer = (state = initialState, action) => {
    switch (action.type) {
      case GET_NFT:
        return {
          ...initialState,
          loading: true,
        };
      case GET_NFT_SUCCESS:
        console.log('Success',action.payload)
        return {
          ...state,
          loading: false,
          nftData: action.payload
        };
      case NFT_API_ERROR:
        return {
          ...initialState,
          loading: false,
          errorMsg: action.payload,
        };
      default:
        return state;
    }
  }
  export default nftReducer;
  